import { Utils } from '../../Core';
import { geoLocationApi as API } from '../../Apis';
import { FindLocationType } from '../../Types/GeoLocation.types';
import { mocksService } from './GeoLocation.mocks';
import dataFields from '../../Types/GeoLocation.json';

const invokeApiFunction = async (stateRequestParameters: {
  locationType: FindLocationType;
  input: string;
  language?: string;
}) =>
  API.call.get({
    locationType: stateRequestParameters.locationType,
    input: stateRequestParameters.input,
    language: stateRequestParameters?.language,
  });

export const { machine, Docs } = Utils.genericMachine({
  invokeApiFunction,
  definitionsAPI: API.definitions,
  mocksService,
  dataFields,
});
